const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Footer/CommonFooter.tsx';
import * as React from 'react';
import { ReactNode } from 'react';
import { css, cx } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';

const footerClassName = css`
    display: flex;

    // This component assumes (at least) 3 child elements.
    // Each element is wrapped, first is aligned left, second is aligned center,
    // and third is aligned right.

    & > div {
        flex: none;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
    }

    & > div:first-child {
        flex: 1;
        justify-content: left;
    }

    & > div:last-child {
        flex: 1;
        justify-content: right;
    }
`;

const frameStyle = css`
    background-color: ${theme.palette.background.paper};
    box-shadow: ${theme?.custom?.shadowFooter};
    z-index: 1;
    padding: 0;
    margin-top: auto;
`;

interface Props {
    className?: string;
    children: ReactNode[];
}

export const CommonFooter = (props: Props) => {
    return (
        <footer id="ccfooter" className={cx(footerClassName, frameStyle, props.className)}>
            {props.children.map((child, index) => (
                <div key={index}>{child}</div>
            ))}
        </footer>
    );
};

export default CommonFooter;
